import app from 'flarum/common/app';

app.initializers.add('huseyinfiliz/bump', () => {
  console.log('[huseyinfiliz/bump] Hello, forum and admin!');
});
